:host {
  @apply block;
}

::slotted([slot=slides]) {
  @apply overflow-visible;
}
